import { Navigate, useLocation } from "react-router-dom";
import { ReactNode } from "react";
import { useAuth } from "@/context/AuthContext";
import { userHasCapability } from "@costadorada/shared";
import type { Role, Capability } from "@costadorada/shared";

interface Props {
  children: ReactNode;
  allowed?: Role[];
  // Escape hatch: users holding this capability pass even if their role isn't in `allowed`
  capability?: Capability;
}

export function ProtectedRoute({ children, allowed, capability }: Props) {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen text-slate-500">Cargando…</div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (
    allowed &&
    !allowed.includes(user.role) &&
    !(capability && userHasCapability(user, capability))
  ) {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
}
